import { render } from "./AppBarSettingsMenu.vue?vue&type=template&id=a9e0d190&scoped=true"
import script from "./AppBarSettingsMenu.vue?vue&type=script&lang=js"
export * from "./AppBarSettingsMenu.vue?vue&type=script&lang=js"

import "./AppBarSettingsMenu.vue?vue&type=style&index=0&id=a9e0d190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e0d190"]])

export default __exports__